<div class="container-v2 ui-page-shell-modern codigos-servico" lang="pt-BR">
  <div class="cs-toolbar">
    <div class="cs-search">
      <label for="cs-search-input">Buscar</label>
      <input id="cs-search-input"
             type="text"
             [ngModel]="searchTerm"
             (ngModelChange)="onSearchChange($event)"
             placeholder="Buscar por código ou descrição do item" />
    </div>

    <button type="button" class="ui-btn ui-btn--primary ui-btn--lg cs-add-btn" (click)="openCreateModal()">
      <app-svg-icon src="assets/icons/plus-solid-icon.svg" color="white" width="13px" height="13px"></app-svg-icon>
      Código de Serviço
    </button>
  </div>

  <div class="cs-table-card">
    <table class="cs-table">
      <thead>
        <tr>
          <th class="col-code">Código Item Lei 116</th>
          <th class="col-description">Descrição Item Lei 116</th>
          <th class="col-rate" *ngFor="let col of rateColumns">{{ col.label }}</th>
          <th class="col-total">Total Retido</th>
          <th class="col-status">Status</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="items.length === 0">
          <td class="cs-empty" [attr.colspan]="rateColumns.length + 5">Nenhum registro encontrado.</td>
        </tr>
        <tr *ngFor="let item of items">
          <td class="col-code"><strong>{{ item.code }}</strong></td>
          <td class="col-description">{{ item.description }}</td>
          <td class="col-rate" *ngFor="let col of rateColumns">
            <ng-container *ngIf="hasRate(item[col.key]); else emptyRate">{{ item[col.key] | number: '1.1-2' }}%</ng-container>
          </td>
          <td class="col-total">
            <strong *ngIf="hasRate(item.totalRate); else emptyRate">{{ item.totalRate | number: '1.0-2' }}%</strong>
          </td>
          <td class="col-status">
            <app-status-badge [label]="item.isEnabled ? 'Ativo' : 'Inativo'"
                              [tone]="item.isEnabled ? 'success' : 'neutral'"
                              size="sm"></app-status-badge>
          </td>
          <td class="col-actions">
            <div class="cs-actions">
              <button class="cs-icon-btn cs-icon-btn--edit" type="button" title="Editar" aria-label="Editar" (click)="openEditModal(item)">
                <i class="fa"
                   style="--svg-icon-url: url('assets/icons/edit-icon.svg'); --svg-icon-color: #ffffff; --svg-icon-width: 14px; --svg-icon-height: 14px;"></i>
              </button>
              <button class="cs-icon-btn cs-icon-btn--delete" type="button" title="Excluir" aria-label="Excluir" (click)="confirmRemove(item)">
                <i class="fa"
                   style="--svg-icon-url: url('assets/icons/trash-icon.svg'); --svg-icon-color: var(--danger-color); --svg-icon-width: 14px; --svg-icon-height: 14px;"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #emptyRate>—</ng-template>
  </div>

  <p class="cs-footnote">
    Os códigos aceitos seguem a lista de serviços da Lei Complementar 116/2003 e definem quais impostos serão retidos
    automaticamente na nota fiscal de cada parceiro.
  </p>

  <div class="modal-overlay" role="presentation" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="modal-box cs-modal cs-modal--delete" role="presentation" (click)="$event.stopPropagation()">
      <h2>Excluir código de serviço</h2>
      <p class="cs-delete-message">
        O código <strong>{{ selectedItem?.code }} — {{ selectedItem?.description }}</strong> deixará de ser usado para
        identificar as retenções dos parceiros vinculados. Deseja continuar?
      </p>
      <div class="cs-modal-actions">
        <button class="ui-btn ui-btn--secondary" type="button" (click)="closeDeleteModal()">Cancelar</button>
        <button class="ui-btn cs-btn-danger" type="button" (click)="executeDelete()">Excluir</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" role="presentation" *ngIf="showEditModal" (click)="closeEditModal()">
    <div class="modal-box cs-modal" role="presentation" (click)="$event.stopPropagation()">
      <h2>{{ selectedItem ? 'Editar' : 'Novo' }} Código de Serviço</h2>
      <p class="cs-modal-subtitle">Cadastre o código de serviço e o percentual de retenção de cada imposto.</p>

      <div class="modal-error" *ngIf="modalErrorMessage">
        {{ modalErrorMessage }}
      </div>

      <div class="cs-modal-fields">
        <div class="cs-field cs-field--code">
          <label for="sc-code">Código do Serviço</label>
          <input id="sc-code" type="text" maxlength="20" placeholder="00.00" [(ngModel)]="form.code" />
          <div class="field-error" *ngIf="formErrors['code']">{{ formErrors['code'] }}</div>
        </div>
        <div class="cs-field cs-field--description">
          <label for="sc-description">Descrição do Serviço</label>
          <input id="sc-description" type="text" maxlength="500" placeholder="Ex.: Agenciamento, corretagem ou intermediação..." [(ngModel)]="form.description" />
          <div class="field-error" *ngIf="formErrors['description']">{{ formErrors['description'] }}</div>
        </div>
        <div class="cs-field cs-field--status">
          <label for="sc-status">Status</label>
          <select id="sc-status" [(ngModel)]="form.isEnabled">
            <option [ngValue]="true">Ativo</option>
            <option [ngValue]="false">Inativo</option>
          </select>
        </div>
      </div>

      <div class="rates-section">
        <h3>Percentuais de retenção (%) — deixe vazio quando não houver retenção</h3>
        <div class="rates-grid">
          <div class="cs-field" *ngFor="let col of rateColumns">
            <label [for]="'sc-' + col.key">{{ col.label }}</label>
            <input [id]="'sc-' + col.key"
                   type="text"
                   inputmode="decimal"
                   placeholder="0,00"
                   appPercentMask
                   [appPercentDecimal]="true"
                   [appPercentSuffix]="false"
                   [(ngModel)]="form.rates[col.key]"
                   [name]="col.key" />
          </div>
        </div>
        <div class="field-error" *ngIf="formErrors['rates']">{{ formErrors['rates'] }}</div>
        <div class="rates-total">
          <span>Total retido</span>
          <strong>{{ formTotalRate > 0 ? (formTotalRate | number: '1.0-2') + '%' : '—' }}</strong>
        </div>
      </div>

      <div class="cs-modal-actions">
        <button class="ui-btn ui-btn--secondary" type="button" (click)="closeEditModal()">Cancelar</button>
        <button class="ui-btn ui-btn--primary" type="button" (click)="saveItem()">Salvar</button>
      </div>
    </div>
  </div>
</div>
